import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useCustomer } from '../../contexts/CustomerContext';
import './TeamSelectionPage.css';
import ErrorDisplay from '../common/ErrorDisplay'; // Import the new component
import logger from '../../utils/logger'; // Import logger

const TeamSelectionPage: React.FC = () => {
  const {
    availableCustomers,
    selectCustomerById,
    isLoadingCustomers,
    error,
  } = useCustomer();
  const navigate = useNavigate();

  // DONT do automatic redirect to pulse if a team is selected
  // allow the users to still select a team
  // useEffect(() => {
  //   // If a customer is already selected (e.g., from a previous session or auto-selection),
  //   // and the user lands on /teams, redirect them to /pulse.
  //   // Or, if only one customer is available and auto-selected by context, redirect.
  //   if (selectedCustomer) {
  //     logger.info(`Customer already selected (${selectedCustomer.name}), redirecting to /pulse from /teams.`);
  //     navigate('/pulse');
  //   }
  // }, [selectedCustomer, navigate]);

  const handleTeamSelect = async (customerId: string) => {
    await selectCustomerById(customerId);
    // The useEffect above will catch the selectedCustomer change and navigate.
    // Or, let us navigate explicitly here after selection:
    navigate('/pulse');
  };

  if (isLoadingCustomers) {
    return <div className="team-selection-container"><p>Loading available teams...</p></div>;
  }

  if (error) {
    return (
      <ErrorDisplay
        sectionTitle="Team Selection Error"
        errorMessage={
          <>
            Failed to load available teams.
            <br />
            <strong>Details:</strong> <span  style={{color: "pink"}}>{error}</span>
            <br />
            <em>Please try again later or contact support if the issue persists.</em>
          </>
        }
        navButtonText="Go to Home"
        navButtonLink="/"
      />
    );
  }

  if (availableCustomers.length === 0) {
    return (
      <ErrorDisplay
        sectionTitle="No Teams Found"
        errorMessage={
          <>
            You do not seem to have access to any teams yet.
            <br />
            Please contact support or create a new team if applicable.
            <br />
            You can also <a href="/docs/onboarding" className="text-indigo-400 hover:text-indigo-300">read our onboarding guide</a>.
          </>
        }
        // Optional: Add a button to contact support or go home
        navButtonText="Go to Home"
        navButtonLink="/"
      />
    );
  }

  // If there's only one customer, auto-select and navigate
  if (availableCustomers.length === 1) {
    const singleCustomer = availableCustomers[0];
    logger.info(`Single customer ('${singleCustomer.name}') found, auto-selecting and navigating to /pulse.`);
    handleTeamSelect(singleCustomer.id);
    return <div className="team-selection-container"><p>Redirecting to your team's Pulse...</p></div>; // Show a brief message during navigation
  }

  // If we reach here, it means isLoadingCustomers is false, no error,
  // and either multiple customers are available or a single one that wasn't auto-redirected.
  return (
    <div className="team-selection-container">
      <h2>Select a Team</h2>
      <p>Please choose a team to view its Pulse.</p>
      <div className="team-list">
        {availableCustomers.map(customer => (
          <button
            key={customer.id}
            onClick={() => handleTeamSelect(customer.id)}
            className="team-card deriq-action-button" // Reusing your action button style
          >
            <h3>{customer.name}</h3>
          </button>
        ))}
      </div>
      {/* <div className="mt-8 text-center">
        <Link to="/dinternal" className="text-sm text-link-color hover:underline">
          Go to Internal Tools
        </Link>
      </div> */}
      
    </div>
  );
};

export default TeamSelectionPage;